<template>
   <div tabindex="0" class="container" :class="{abierto: abierto}" @focus="focus" @blur="blur">
      <div class="img-container">
        <img src="@/assets/img/home_screen/PlanetaEstudiante.png" alt="">
      </div>
      <div class="text-box">
        <div class="titulo">
          <h2>{{titulo}}</h2>
        </div>
        <div class="texto scroll-light">
          <p>{{texto}}</p>
        </div>
        <div class="boton">
          <button class="btn btn-primary" @focus="focoB = true" @blur="focoB = false" @click.stop="abrir">{{textoBtn}}</button>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "marte",
  props: {},
  data(){
    return {
      focoP: false,
      focoB: false,
    }
  },
  computed:{
    titulo(){
      return this.$store.getters.homeScreen.planeta_estudiantes.titulo;
    },
    texto(){
      return this.$store.getters.homeScreen.planeta_estudiantes.texto;
    },
    textoBtn(){
      return this.$store.getters.homeScreen.planeta_estudiantes.boton;
    },
    abierto(){
      return this.focoP || this.focoB;
    }
  },
  methods:{
    focus(){
      this.$globalEvent.$emit('slideSound');
      this.focoP = true;
    },
    blur(){
      this.focoP = false;
    },
    abrir(){
      this.$emit('marte-click');
    }
  } 
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/responsiveness.scss";

.container {
  box-sizing: border-box;
  color: white;
  align-items: center;
  justify-content: center;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  width: 600px;
  max-width: 50%;
  height: 300px;
  max-height: 100%;
  display: flex;
  flex-direction: row;
  @include mobile{
    width: 100%;
    max-width: 100%;
    max-height: 40%;
  }
}

.img-container{
  cursor: url('~@/assets/img/cursors/pointer.png'), pointer;
  z-index: 1;
  width: 50%;
  height: 100%;
  transition: transform 500ms;
  will-change: transform;
  transform: translateX(50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-container > img{
  animation: float 6s ease-in-out alternate infinite;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  width: auto;
  height: auto;
  max-width:80%;
  max-height:100%;
  transform-origin: 50% 50%;
  backface-visibility: hidden;
  will-change: transform, drop-shadow;
  // transition: transform 500ms;
  // transform: scale(1,1);
}

.container.abierto .img-container{
  transform: translateX(0px);
}

.text-box{
  box-sizing: border-box;
  // z-index: 2;
  text-align: left;
  transition: transform 500ms;
  width: 50%;
  height: 100%;
  transform: translateX(-50%);
  text-shadow: 0px 0px 5px #000000;
  display: flex;
  flex-direction: column;
}

.titulo{
  flex-shrink: 0;
  padding: 0px 15px 0px 15px;
  margin-top: -40px;
  opacity: 1;
  text-align: center;
  line-height: 25px;
}
.texto{
  font-size: 14pt;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; 
  -ms-overflow-style: -ms-autohiding-scrollbar;
  flex-shrink: 1;
  padding: 0px 15px 0px 15px;
  opacity: 0;
  transition: opacity 500ms;
  // background-color: rgba(0,0,0,0.2);
  mask-image: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 5%,rgba(0,0,0,1) 95%,rgba(0,0,0,0) 100%);
  // mask-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));
}
.boton{
  flex-shrink: 0;
  padding: 15px 15px 0px 15px;
  opacity: 0;
  transition: opacity 500ms;
}

.container.abierto .text-box{
  transform: translateX(0px);
}

.container.abierto .texto, .container.abierto .boton{
  opacity: 1;
}

@keyframes float{
  0% {transform: translateY(0px) translateX(0px);}
  25% {transform: translateY(10px) translateX(10px);}
  50% {transform: translateY(0px) translateX(10px);}
  75% {transform: translateY(10px) translateX(0px);}
  100% {transform: translateY(0px) translateX(0px);}
}
</style>
